export default __webpack_public_path__ + "static/media/banner-applicant.273557c4.svg";